import { FC } from 'react';
import TermsAcceptanceModalBase from './terms-acceptance-modal-base';

export interface ITermsAcceptanceModalProps {
    termsContent: string;
    onAccept: () => Promise<void>;
}

const TermsAcceptanceModal: FC<ITermsAcceptanceModalProps> = ({
    termsContent,
    onAccept,
}) => (
    <TermsAcceptanceModalBase
        termsContent={termsContent}
        onAccept={onAccept}
    />
);

export default TermsAcceptanceModal;
